<template>
  <div>
    <div v-for="(item, key) in config" :key="key" :item="item">
      {{ key }}
      <el-input v-model="temp[key]" @input="change" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      temp: {}
    }
  },
  props: ['config', 'value'],
  methods: {
    change (value) {
      this.$emit('input', JSON.stringify(this.temp))
    }
  },
  mounted () {
    this.temp = this.value ? JSON.parse(this.value) : {}
  },
  watch: {
    config: function (val, oldVal) {
      if (!val) {
        return
      }
      let temp = {}
      for (var key in val) {
        temp[key] = val[key][1]
      }
      this.temp = temp
    },
    value: function (val, oldVal) {
      this.temp = val ? JSON.parse(val) : {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/views/supplier/SupplierConfig.vue